/* eslint-disable */

/**
 * Dependencies:
 * - Custom select component
 *
 * Required translation strings:
 * - addToCart
 * - noStock
 * - noVariant
 * - onlyXLeft
 */

document.addEventListener('DOMContentLoaded', () => {
  if (!customElements.get('variant-picker')) {
    class VariantPicker extends HTMLElement {
      constructor() {
        super();
        this.section = this.closest('.js-product');
        this.productForm = this.section.querySelector('.js-product-form-main');
        this.optionSelectors = this.querySelectorAll('.option-selector');
        this.data = this.getProductData();

        this.updateAvailability();
        this.addEventListener('change', this.handleVariantChange.bind(this));
      }

      /**
       * Handles 'change' events on the variant picker element.
       * @param {object} evt - Event object.
       */
      handleVariantChange(evt) {
        const productSelector = evt.target.closest(".product-selector")
        if(productSelector) {
          let option = "";
          if(productSelector.dataset.selectorType === 'dropdown') {
            option = productSelector.querySelector('.custom-select__btn').textContent.trim();
          } else {
            option = productSelector.querySelector('input:checked').value;
          }
          if(option && window.productSwitch[option]) {
            window.location = window.productSwitch[option]
          }
        } else {
          const selectedOptions = this.getSelectedOptions();
          //update properties
          selectedOptions.forEach((option, i) => {
            const input = this.querySelector(`.js-option-property[data-option-index="${i}"]`);
            if(input) {
              input.value = option;
            }
          });
          this.variant = null;
    
          // Get selected variant data (if variant exists).
          this.variant = this.data.product.variants.find((v) =>
            v.options.every((val, index) => val === selectedOptions[index])
          );
          if(!this.variant) {
            this.variant = this._getFirstMatchingAvailableVariant();
            //update selectors
            this.variant && this.optionSelectors.forEach((selector, i) => {
              if (selector.dataset.selectorType === 'dropdown') {
                const option = selector.querySelector(`.js-option[data-value="${ this.variant.options[i] }"]`);
                if(option) { selector.querySelector("custom-select")?.selectOption(option); }
              } else {
                const input = selector.querySelector(`input[value="${ this.variant.options[i] }"]`);
                if(input) { input.checked = true; }
              }
            });
          }
    
          if (this.variant) {
            this.sendViewItem();
            this.updateVariantInfos();
            this.updateMedia();
            this.updateUrl(evt);
            this.updateVariantInput();
            this.updateVariantDescription();
          }
    
          this.updateAddToCartButton();
          this.updateAvailability();
          this.updatePrice();
          this.updateBackorderText();
          this.updatePickupAvailability();
          this.updateSku();
          VariantPicker.updateLabelText(evt);
    
          this.dispatchEvent(new CustomEvent('on:variant:change', {
            bubbles: true,
            detail: {
              form: this.productForm,
              variant: this.variant,
              product: this.data.product
            }
          }));
        }
      }

      /**
       * Updates the "Add to Cart" button label and disabled state.
       */
      updateAddToCartButton() {
        this.productForm = this.section.querySelector('.js-product-form-main');
        if (!this.productForm) return;

        this.addBtn = this.addBtn || this.productForm.querySelector('[name="add"]');
        const variantAvailable = this.variant && this.variant.available;
        const unavailableStr = this.variant ? theme.strings.noStock : theme.strings.noVariant;

        this.addBtn.disabled = !variantAvailable;
        this.addBtn.textContent = variantAvailable
          ? this.addBtn.dataset.addToCartText
          : unavailableStr;
      }

      /**
       * Send view_item event.
       */

      sendViewItem() {
        gtag("event", "view_item", {
          'currency': window.theme?.variables?.currency,
          'value': (this.variant.price / 100).toFixed(2),
          'items': [
            {
              'item_id': this.variant.id,
              'item_name': window.product?.title,
              'item_variant': this.variant.title,
              'affiliation': 'Online Store',
              'index': 0,
              'item_category': window.product?.type,
              'item_brand': window.product?.vendor,
              'price': (this.variant.compare_at_price || this.variant.price / 100).toFixed(2),
              'discount': (((this.variant.compare_at_price || this.variant.price) - this.variant.price) / 100).toFixed(2),
              'quantity': 1
            }
          ]
        });
      }

      /**
       * Updates the availability status in option selectors.
       */
      updateAvailability() {
        if (this.dataset.showAvailability === 'false') return;
        let currVariant = this.variant;

        if (!this.variant) {
          currVariant = { options: this.getSelectedOptions() };
        }

        const updateOptionAvailability = (optionEl, available, soldout, availableCombination) => {
          const el = optionEl;
          const text = soldout ? theme.strings.noStock : theme.strings.noVariant;
          el.classList.toggle('is-unavailable', !available);
          el.classList.toggle('hide-unavailable', this.getAttribute("data-hide-unavailable") == "true" && !availableCombination);

          if (optionEl.classList.contains('custom-select__option')) {
            const em = el.querySelector('em');

            if (em) {
              em.hidden = available;
            }

            if (!available) {
              if (em) {
                em.textContent = text;
              } else {
                el.innerHTML = `${el.innerHTML} <em class="pointer-events-none">${text}</em>`;
              }
            }
          } else if (!available) {
            el.nextElementSibling.title = text;
          } else {
            el.nextElementSibling.removeAttribute('title');
          }
        };

        // Flag all options as unavailable
        this.querySelectorAll('.option-selector .js-option').forEach((optionEl) => {
          updateOptionAvailability(optionEl, false, false);
        });

        // Flag selector options as available or sold out, depending on the variant availability
        this.data.options_with_values.forEach((option, optionIndex) => {
          let hideAllOptions = true;

          const selector = this.optionSelectors[optionIndex];
          const options = selector.querySelectorAll('.js-option');

          option["values"].forEach((value, valueIndex) => {
            let hasAtLeastOneCombination = false, hasAvailableVariant = false;
            this.data.product["variants"].some((variant) => {
              if(variant["options"][optionIndex] === value && variant && this.data.formatted[variant.id]?.hidden != true
                && (
                    (optionIndex == 0)
                    || (optionIndex == 1 && currVariant.options[0] == variant.options[0])
                    || (optionIndex == 2 && currVariant.options[0] == variant.options[0] && currVariant.options[1] == variant.options[1])
                  )
              ) {
                hasAtLeastOneCombination = true;

                if(variant["available"]) {
                  hasAvailableVariant = true;
                }

                hideAllOptions = false;
              }
            });

            const optionEl = Array.from(options).find((opt) => {
              if (selector.dataset.selectorType === 'dropdown') {
                return opt.dataset.value === value;
              }
              return opt.value === value;
            });

            if (optionEl) {
              updateOptionAvailability(optionEl, hasAvailableVariant, !hasAvailableVariant, hasAtLeastOneCombination);
            }
          });

          selector.toggleAttribute("hidden", hideAllOptions);
        })
      }
      _getFirstMatchingAvailableVariant() {
        let options = this.getSelectedOptions(), matchedVariant = null, slicedCount = 0;
        do {
          options.pop();
          slicedCount += 1;
          matchedVariant = this.data.product["variants"].find((variant) => {
            return variant["available"] && variant["options"].slice(0, variant["options"].length - slicedCount).every((value, index) => value === options[index]);
          });
        } while (!matchedVariant && options.length > 0);
        return matchedVariant;
      }

      /**
       * Updates the backorder text and visibility.
       */
      updateBackorderText() {
        this.backorder = this.backorder || this.section.querySelector('.backorder');
        if (!this.backorder) return;

        let hideBackorder = true;

        if (this.variant && this.variant.available) {
          const { inventory } = this.data.formatted[this.variant.id];

          if (this.variant.inventory_management && inventory === 'none') {
            const backorderProdEl = this.backorder.querySelector('.backorder__product');
            const prodTitleEl = this.section.querySelector('.product-title');
            const variantTitle = this.variant.title.includes('Default')
              ? ''
              : ` - ${this.variant.title}`;

            backorderProdEl.textContent = `${prodTitleEl.textContent}${variantTitle}`;
            hideBackorder = false;
          }
        }

        this.backorder.hidden = hideBackorder;
      }

      /**
       * Updates the color option label text.
       * @param {object} evt - Event object
       */
      static updateLabelText(evt) {
        const selector = evt.target.closest('.option-selector');
        if (selector.dataset.selectorType === 'dropdown') return;

        const colorText = selector.querySelector('.js-color-text');
        if (!colorText) return;

        colorText.textContent = evt.target.nextElementSibling.querySelector('.js-value').textContent;
      }

      /**
       * Updates variant infos.
       */
      updateVariantInfos() {
        const variantId = this.variant.id;
        //console.log('Variant ID:', variantId);
        //console.log('Variant Infos:', window.variantInfos);
        
        if (window.variantInfos && window.variantInfos[variantId]) {
          document.querySelectorAll(".js-update-variant-data").forEach((el) => {
            if (el.tagName === "INPUT") {
              el.value = window.variantInfos[variantId][el.getAttribute("data-attr")] || "";
            } else {
              el.innerHTML = window.variantInfos[variantId][el.getAttribute("data-attr")] || "";
              el.classList.toggle("hidden", !window.variantInfos[variantId][el.getAttribute("data-attr")]);
            }
          });
          document.querySelectorAll(".js-update-variant-data-visibility").forEach((el) => {
            el.classList.toggle("hidden", window.variantInfos[variantId][el.getAttribute("data-attr")] == el.getAttribute("data-state"));
          });
        } else {
          console.warn(`No variant info found for variant id: ${variantId}`);
        }
      }

      /**
       * Updates the product media.
       */
      updateMedia() {
        if (!this.variant.featured_media) return;

        if (this.section.matches('quick-add-drawer')) {
          this.section.updateMedia(this.variant.featured_media.id);
        } else {
          this.mediaGallery = this.mediaGallery || this.section.querySelector('media-gallery');
          if (!this.mediaGallery) return;

          const variantMedia = this.mediaGallery.querySelector(
            `[data-media-id="${this.variant.featured_media.id}"]`
          );
          this.mediaGallery.setActiveMedia(variantMedia, true, true);
        }
      }

      /**
       * Updates the pick up availability.
       */
      updatePickupAvailability() {
        this.pickUpAvailability =
          this.pickUpAvailability || this.section.querySelector('pickup-availability');
        if (!this.pickUpAvailability) return;

        if (this.variant && this.variant.available) {
          this.pickUpAvailability.getAvailability(this.variant.id);
        } else {
          this.pickUpAvailability.removeAttribute('available');
          this.pickUpAvailability.innerHTML = '';
        }
      }

      /**
       * Updates the price.
       */
      updatePrice() {
        this.price = this.price || this.section.querySelector('.product-info__price > .price');
        if (!this.price) return;

        if (this.variant) {
          const priceCurrentEl = this.price.querySelector('.price__current');
          const priceWasEl = this.price.querySelector('.price__was');
          const unitPriceEl = this.price.querySelector('.unit-price');

          // Update current price and original price if on sale.
          priceCurrentEl.innerHTML = this.data.formatted[this.variant.id].price;
          if (priceWasEl)
            priceWasEl.innerHTML = this.data.formatted[this.variant.id].compareAtPrice || '';

          // Update unit price, if specified.
          if (this.variant.unit_price_measurement) {
            const valueEl = this.price.querySelector('.unit-price__price');
            const unitEl = this.price.querySelector('.unit-price__unit');
            const value = this.variant.unit_price_measurement.reference_value;
            const unit = this.variant.unit_price_measurement.reference_unit;

            valueEl.innerHTML = this.data.formatted[this.variant.id].unitPrice;
            unitEl.textContent = value === 1 ? unit : `${value} ${unit}`;
          }

          unitPriceEl.hidden = !this.variant.unit_price_measurement;
          this.price.classList.toggle(
            'price--on-sale',
            this.variant.compare_at_price > this.variant.price
          );
          this.price.classList.toggle('price--sold-out', !this.variant.available);

          // Update unit grossprice
          const netPrice = this.variant.price / 100; // Assuming the price is in cent
          updateBruttoPriceElement(netPrice);

          // Update the value of the hidden gross price input element
          const bruttoPriceInfo = document.getElementById('brutto-price-info');
          const bruttoPriceInput = document.getElementById('brutto-price-input');
          if (bruttoPriceInfo && bruttoPriceInput) {
            const bruttoPriceText = bruttoPriceInfo.textContent || bruttoPriceInfo.innerText;
            bruttoPriceInput.value = bruttoPriceText;
          }

          // Netto-Preise bei "Größe"-Buttons updaten, 
          // abhängig von der aktuell gewählten Tonnenstellung = this.variant.options[1]
          if (this.data && this.data.product && this.variant.options.length > 1) {
            const selectedTonnenstellung = this.variant.options[1];
            console.log('[VariantPicker] calling updateSizeButtonsNetPrice with', selectedTonnenstellung);
            updateSizeButtonsNetPrice(this.data.product, selectedTonnenstellung);
          }
        }

        this.price.querySelector('.price__default').hidden = !this.variant;
        this.price.querySelector('.price__no-variant').hidden = this.variant;
      }

      /**
       * Updates the SKU.
       */
      updateSku() {
        this.sku = this.sku || this.section.querySelector('.product-sku__value');
        if (!this.sku) return;

        const skuAvailable = this.variant && this.variant.sku;
        this.sku.textContent = skuAvailable ? this.variant.sku : '';
        this.sku.parentNode.hidden = !skuAvailable;
      }

      /**
       * Updates the url with the selected variant id.
       * @param {object} evt - Event object.
       */
      updateUrl(evt) {
        if (!evt || evt.type !== 'change' || this.dataset.updateUrl === 'false') return;
        window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.variant.id}`);
      }

      /**
       * Updates the value of the hidden [name="id"] form inputs.
       */
      updateVariantInput() {
        this.forms =
          this.forms || this.section.querySelectorAll('.js-product-form-main, .js-instalments-form');

        this.forms.forEach((form) => {
          const input = form.querySelector('input[name="id"]');
          input.value = this.variant.id;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });

        document.querySelectorAll(".js-dynamic-variant-input").forEach((input) => {
          input.value = this.variant.title;
        });
      }

      /**
       * Updates the Variant Metafield Description/Features
       */
      updateVariantDescription() {
        const variantId = this.variant.id;
        //console.log('updateVariantDescription - Variant ID:', variantId);
        
        if (window.variantInfos && window.variantInfos[variantId]) {
          // Beschreibung aktualisieren
        } else {
          console.warn(`No variant info found for variant id: ${variantId}`);
        }

        let selectedVariantId = this.variant.id;
        //console.log('Selected Variant ID:', selectedVariantId);

        // Prüfen, ob window.product und window.product.variants existieren
        if (!window.product) {
          console.error('window.product is not defined');
          return;
        }

        if (!window.product.variants) {
          console.error('window.product.variants is not defined');
          console.log('window.product:', window.product);
          return;
        }

        // Prüfen, ob die ausgewählte Variante in window.product.variants vorhanden ist
        let variantData = window.product.variants[selectedVariantId];
        if (!variantData) {
          console.error(`Variant data for ID ${selectedVariantId} not found`);
          console.log('window.product.variants:', window.product.variants);
          return;
        }

        let description = variantData.description || window.product.description || '';
        //console.log('Description:', description);
        let descriptionTabs = document.querySelectorAll(".variant_description_tab");
        descriptionTabs.forEach((tab => {
          if (description === '') {
            tab.classList.add("hidden");
          } else {
            tab.classList.remove("hidden");
          }
        }));

        let features = variantData.features || window.product.features || '';
        //console.log('Features:', features);
        let featuresTabs = document.querySelectorAll(".variant_features_tab");
        featuresTabs.forEach((tab => {
          if (features === '') {
            tab.classList.add("hidden");
          } else {
            tab.classList.remove("hidden");
          }
        }));

        let descriptionElements = document.querySelectorAll(".product-variant_description__block_content");
        let descriptionTitles = document.querySelectorAll(".product-variant_description__block_title");

        let featuresElements = document.querySelectorAll(".product-variant_features__block_content");
        let featuresTitles = document.querySelectorAll(".product-variant_features__block_title");

        descriptionTitles.forEach(element => {
          if (description === '') {
            element.classList.add("hidden");
          } else {
            element.classList.remove("hidden");
            element.innerText = (variantData.description ? window.product.variantDescriptionHeading : window.product.descriptionHeading) || '';
          }
        });
        descriptionElements.forEach(element => {
          element.innerHTML = description;
        });

        featuresTitles.forEach(element => {
          const tab = element.closest(".tablist__tab");
          if (features === '') {
            element.classList.add("hidden");
            tab?.classList.add("hidden");
          } else {
            element.classList.remove("hidden");
            tab?.classList.remove("hidden");
            element.innerText = window.product.variantFeaturesHeading || '';
            element.innerText = (variantData.features ? window.product.variantFeaturesHeading : window.product.featuresHeading) || '';
          }
        });
        featuresElements.forEach(element => {
          element.innerHTML = features;
        });
      }

      /**
       * Gets the selected option element from each selector.
       * @returns {Array}
       */
      getSelectedOptions() {
        const selectedOptions = [];

        this.optionSelectors.forEach((selector) => {
          if (selector.dataset.selectorType === 'dropdown') {
            selectedOptions.push(selector.querySelector('.custom-select__btn').textContent.trim());
          } else {
            selectedOptions.push(selector.querySelector('input:checked').value);
          }
        });

        return selectedOptions;
      }

      /**
       * Gets the product data.
       * @returns {?object}
       */
      getProductData() {
        const dataEl = this.querySelector('[type="application/json"]');
        return JSON.parse(dataEl.textContent);
      }
    }

    customElements.define('variant-picker', VariantPicker);
  }
});

// ----------------------------------------------------------
// Definition außerhalb der Klasse:
function updateSizeButtonsNetPrice(product, selectedTonnenstellung) {
  console.log('[updateSizeButtonsNetPrice] Start:', product, selectedTonnenstellung);

  const sizeFieldset = document.querySelector('fieldset[data-option-name="Größe"]');
  if (!sizeFieldset) {
    console.warn('[updateSizeButtonsNetPrice] Kein data-option-name="Größe"-Feldset im DOM!');
    return;
  }

  const sizeRadios = sizeFieldset.querySelectorAll('input.js-option');
  if (!sizeRadios.length) {
    console.warn('[updateSizeButtonsNetPrice] Keine Radio-Buttons für Größe gefunden!');
    return;
  }

  sizeRadios.forEach(radio => {
    const sizeValue = radio.value;
    console.log('Prüfe SizeValue:', sizeValue, 'Tonnenstellung:', selectedTonnenstellung);

    // Prüfe hier die Index-Reihenfolge in variant.options[]
    const matchedVariant = product.variants.find(v => {
      return (
        v.options[0] === sizeValue &&
        v.options[1] === selectedTonnenstellung
      );
    });

    if (!matchedVariant) {
      console.warn('Keine Variante gefunden für:', sizeValue, selectedTonnenstellung);
    } else {
      console.log('Gefundene Variante:', matchedVariant.id, matchedVariant.options);
      const netPrice = matchedVariant.price / 100;
      const labelSpan = sizeFieldset.querySelector(`label[for="${radio.id}"] span`);
      if (labelSpan) {
        labelSpan.innerHTML = `${sizeValue}<br><span class="price-on-button">${netPrice.toFixed(2).replace('.', ',')} €</span>`;
      }
    }
  });
}